import * as i0 from '@angular/core';
import { EventEmitter, Directive, Output, NgModule } from '@angular/core';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
class InfiniteScrollingDirective {
  constructor(elm) {
    this.elm = elm;
    this.endScroll = new EventEmitter();
    this.scrollEvent = new EventEmitter();
  }
  ngOnInit() {
    this.onScroll.bind(this);
    this.registerScrollEvent();
  }
  registerScrollEvent() {
    fromEvent(this.elm.nativeElement, 'scroll').pipe(debounceTime(100)).subscribe(event => {
      this.scrollEvent.emit({
        event
      });
      if (Math.ceil(this.elm.nativeElement.scrollTop + this.elm.nativeElement.offsetHeight + 1) >= this.elm.nativeElement.scrollHeight) {
        this.onScroll(event);
      }
    });
  }
  onScroll(event) {
    this.endScroll.emit({
      event: event
    });
  }
  /** @nocollapse */
  static {
    this.ɵfac = function InfiniteScrollingDirective_Factory(t) {
      return new (t || InfiniteScrollingDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  /** @nocollapse */
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: InfiniteScrollingDirective,
      selectors: [["", "cxoneInfiniteScrolling", ""]],
      outputs: {
        endScroll: "endScroll",
        scrollEvent: "scrollEvent"
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InfiniteScrollingDirective, [{
    type: Directive,
    args: [{
      selector: '[cxoneInfiniteScrolling]'
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    endScroll: [{
      type: Output
    }],
    scrollEvent: [{
      type: Output
    }]
  });
})();
class InfiniteScrollingModule {
  /** @nocollapse */static {
    this.ɵfac = function InfiniteScrollingModule_Factory(t) {
      return new (t || InfiniteScrollingModule)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: InfiniteScrollingModule
    });
  }
  /** @nocollapse */
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InfiniteScrollingModule, [{
    type: NgModule,
    args: [{
      declarations: [InfiniteScrollingDirective],
      imports: [],
      exports: [InfiniteScrollingDirective]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { InfiniteScrollingDirective, InfiniteScrollingModule };
